export const STEP_2_FORM_REQ = "STEP_2_FORM_REQ";
export const STEP_2_FORM_SUCCESS = "STEP_2_FORM_SUCCESS";
export const STEP_2_FORM_FAILED = "STEP_2_FORM_FAILED";
export const STEP_2_FORM_RESET = "STEP_2_FORM_RESET";

export const STEP_3_FORM_REQ = "STEP_3_FORM_REQ";
export const STEP_3_FORM_SUCCESS = "STEP_3_FORM_SUCCESS";
export const STEP_3_FORM_FAILED = "STEP_3_FORM_FAILED";
export const STEP_3_FORM_RESET = "STEP_3_FORM_RESET";

export const TLAT_DETAILS_FORM_REQ = "TLAT_DETAILS_FORM_REQ";
export const TLAT_DETAILS_FORM_SUCCESS = "TLAT_DETAILS_FORM_SUCCESS";
export const TLAT_DETAILS_FORM_FAILED = "TLAT_DETAILS_FORM_FAILED";
export const TLAT_DETAILS_FORM_RESET = "TLAT_DETAILS_FORM_RESET";
